/**
 * TrendModa — Ultra-Reliable Infinite Scroll (v3.2 Singleton)
 */
(function() {
  'use strict';

  if (window.tmInfiniteInstance) {
    window.tmInfiniteInstance.init();
    return;
  }

  class TMInfiniteScroll {
    constructor() {
      this.isLoading = false;
      this.nextPageUrl = null;
      // Sayfanın altına bu kadar kala yüklemeye başla → kullanıcı için "anında" hissi
      this.TRIGGER_DISTANCE = 1200;
      this.io = null;
      // scroll/resize yedeği (IO prerender/Safari'de tetiklenmezse devreye girer)
      this.checkHandler = this.rafThrottle(this.checkAndLoad.bind(this));
      this.eventsBound = false;

      this.init();
    }

    init() {
      this.grid = document.querySelector('#ProductGridContainer .ty-product-grid') || document.getElementById('product-grid');
      this.sentinel = document.getElementById('infinite-scroll-sentinel');
      this.loader = document.getElementById('infinite-scroll-loader');
      this.skeleton = document.getElementById('tm-skeleton-loader');
      this.container = document.getElementById('ProductGridContainer');

      if (this.io) { this.io.disconnect(); this.io = null; }

      if (!this.grid || !this.sentinel) {
        this.nextPageUrl = null;
        return;
      }

      this.nextPageUrl = this.sentinel.dataset.nextUrl;
      if (!this.nextPageUrl) {
        if (this.loader) this.loader.style.display = 'none';
        if (this.skeleton) this.skeleton.style.display = 'none';
        return;
      }

      this.observeSentinel();
      this.bindEvents();
      // Sayfa kısa/sentinel zaten görünürse hemen yükle (IO'nun ilk tetiklemesini bekleme).
      // Tarayıcı boşta kalana kadar bekle: filtre sonrası grid'in tamamı yeniden render
      // edilirken erken bir getBoundingClientRect() çağrısı zorla senkron layout'a
      // (layout thrashing) yol açıp mobilde donma hissi yaratıyordu.
      this.scheduleIdleCheck();
    }

    scheduleIdleCheck() {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(() => this.checkAndLoad(), { timeout: 500 });
      } else {
        requestAnimationFrame(() => requestAnimationFrame(() => this.checkAndLoad()));
      }
    }

    observeSentinel() {
      if (!('IntersectionObserver' in window) || !this.sentinel) return;
      this.io = new IntersectionObserver((entries) => {
        if (entries[0] && entries[0].isIntersecting) this.loadNextPage();
      }, { rootMargin: this.TRIGGER_DISTANCE + 'px 0px' });
      this.io.observe(this.sentinel);
    }

    bindEvents() {
      if (this.eventsBound) return;
      this.eventsBound = true;
      window.addEventListener('scroll', this.checkHandler, { passive: true });
      window.addEventListener('resize', this.checkHandler, { passive: true });
    }

    // IO tetiklemese bile sentinel tetik bölgesindeyse yükle
    checkAndLoad() {
      if (this.isLoading || !this.nextPageUrl || !this.sentinel) return;
      const rect = this.sentinel.getBoundingClientRect();
      if (rect.top <= window.innerHeight + this.TRIGGER_DISTANCE) {
        this.loadNextPage();
      }
    }

    async loadNextPage() {
      if (this.isLoading || !this.nextPageUrl) return;

      this.isLoading = true;
      if (this.skeleton) this.skeleton.classList.add('is-loading');
      if (this.loader) this.loader.classList.add('is-loading');

      const fetchUrl = this.nextPageUrl;

      try {
        const response = await fetch(fetchUrl);
        if (!response.ok) throw new Error(`HTTP Error: ${response.status}`);
        
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Only grab products that are actually inside the grid
        const newProducts = doc.querySelectorAll('#product-grid > .ty-card, #product-grid > .grid__item, #product-grid > .card-wrapper');
        const nextSentinel = doc.getElementById('infinite-scroll-sentinel');
        
        if (newProducts.length > 0) {
          const fragment = document.createDocumentFragment();
          newProducts.forEach(product => {
            // Ensure we don't append duplicates
            const variantId = product.dataset.variantId;
            if (variantId && this.grid.querySelector(`[data-variant-id="${variantId}"]`)) {
              return;
            }
            fragment.appendChild(product);
          });
          this.grid.appendChild(fragment);
        }

        // Update the sentinel in the DOM
        if (nextSentinel && nextSentinel.dataset.nextUrl) {
          this.nextPageUrl = nextSentinel.dataset.nextUrl;
          if (this.sentinel) {
            this.sentinel.dataset.nextUrl = this.nextPageUrl;
          }
        } else {
          this.nextPageUrl = null;
          if (this.io) { this.io.disconnect(); this.io = null; }
          this.teardownEvents();
          if (this.sentinel) this.sentinel.remove();
          if (this.loader) this.loader.remove();
          if (this.skeleton) this.skeleton.remove();
        }

        this.reinitTheme();

      } catch (err) {
        console.error('[TM InfiniteScroll] Failed:', err);
      } finally {
        this.isLoading = false;
        if (this.skeleton) this.skeleton.classList.remove('is-loading');
        if (this.loader) this.loader.classList.remove('is-loading');

        // Sentinel hâlâ tetik bölgesindeyse (büyük ekran/az ürün) bir sonraki sayfayı da getir
        if (this.nextPageUrl) {
          this.scheduleIdleCheck();
        }
      }
    }

    reinitTheme() {
      if (window.tmLazy && typeof window.tmLazy.initImageLazyLoad === 'function') {
        window.tmLazy.initImageLazyLoad();
      }
      if (window.tmWishlist && typeof window.tmWishlist.syncHearts === 'function') {
        window.tmWishlist.syncHearts();
      }
      document.dispatchEvent(new CustomEvent('collection:reloaded'));
    }

    rafThrottle(func) {
      let ticking = false;
      return () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => { ticking = false; func(); });
      };
    }

    teardownEvents() {
      window.removeEventListener('scroll', this.checkHandler, { passive: true });
      window.removeEventListener('resize', this.checkHandler, { passive: true });
      this.eventsBound = false;
    }
  }

  // Create the singleton instance
  window.tmInfiniteInstance = new TMInfiniteScroll();

  // Watch for AJAX updates (Filtering/Sorting)
  const observer = new MutationObserver((mutations) => {
    // Sonsuz kaydırma ekleme yaparken yeniden başlatma (yalnızca filtre/sıralama gibi
    // grid'in tamamen yenilendiği durumlarda re-init gerekir)
    if (window.tmInfiniteInstance && window.tmInfiniteInstance.isLoading) return;
    for (const mutation of mutations) {
      if (mutation.type === 'childList') {
        if (document.getElementById('product-grid')) {
          window.tmInfiniteInstance.init();
          break;
        }
      }
    }
  });

  const container = document.getElementById('ProductGridContainer');
  if (container) {
    observer.observe(container, { childList: true, subtree: true });
  }

})();
